import { ChangeDetectionStrategy, Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AbstractDialog, AbstractDialogData, AbstractDialogResultData, AgrDialogModule } from '@next/core-lib/dialog';
import { AgrI18nSharedModule } from '@next/core-lib/i18n';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './return-date-help-dialog.component.html',
  imports: [AgrDialogModule, AgrI18nSharedModule],
})
export class ReturnDateHelpDialogComponent extends AbstractDialog<AbstractDialogData> {
  constructor(
    protected mdDialogRef: MatDialogRef<ReturnDateHelpDialogComponent, AbstractDialogResultData<AbstractDialogData>>,
    @Inject(MAT_DIALOG_DATA) public data: AbstractDialogData,
  ) {
    super();
  }
}
